import { useIsMultiProviderScheduleEnabled } from '@/features/flags';
import type { ScheduleItemWithDisplayFacets } from '@/features/sessions/types';
import {
  deriveScheduleFacetOptions,
  type ScheduleFacetOptions,
} from '@/features/sessions/utils/displayFacets';
import { useQueryIntegrationsMixinGetSchedule } from '@/hooks/integrations/integrations-framework/mixins/useQueryIntegrationsMixinGetSchedule';

type Params = {
  scheduleDate: string | undefined;
  enabled: boolean;
};

/** Unfiltered query used only to derive dropdown option metadata. */
export function useScheduleFilterOptions({ scheduleDate, enabled }: Params) {
  const isFlagEnabled = useIsMultiProviderScheduleEnabled();

  return useQueryIntegrationsMixinGetSchedule<ScheduleFacetOptions>({
    start_date: scheduleDate,
    end_date: scheduleDate,
    enabled: enabled && isFlagEnabled,
    select: (schedule) =>
      deriveScheduleFacetOptions(schedule as readonly ScheduleItemWithDisplayFacets[]),
  });
}
